import * as React from 'react'
import classnames from 'classnames'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { Employee } from '../lib/interfaces/Employee.interface'
import { EntityComment } from '../lib/interfaces/EntityComment.interface'

import { formatName } from 'src/lib/helpers/format'

const moment = require('moment')

const get = require('lodash/get')
const map = require('lodash/map')
const size = require('lodash/size')
const take = require('lodash/take')

interface RouteInfo {
	employeeId: string
}

export interface EntityCommentListProps {
	comments?: EntityComment[]
}

export interface EntityCommentListState {
	expanded: boolean
}

class EntityCommentList extends React.PureComponent<EntityCommentListProps, EntityCommentListState> {
  state: EntityCommentListState = {
    expanded: false
  }

  renderEmployeeName(employee?: Employee) {
    return formatName(employee)
  }

  renderComment(comment: EntityComment) {
    return (
      <p key={comment.id} className="mb-1">
        <b>{get(comment, 'createdBy.firstName')}</b>
        <span className="ml-1">{comment.comment}</span>
        <b className="ml-1">{`on ${moment(comment.dateCreated).format('MMMM DD[,] YYYY')}`}</b>
      </p>
    )
  }

  render() {
    const { expanded } = this.state
		const { comments } = this.props
		
		const commentsToShow = expanded ? comments : take(comments, 10)

    return (
      <div className="commentslist">
				{map(commentsToShow, comment => this.renderComment(comment))}
				<div className="mt-1">
					{size(commentsToShow) < size(comments) && (
						<u
							className="cursor-pointer"
							onClick={() => this.setState({ expanded: true })}
						>
							Show all
							<FontAwesomeIcon className="ml-1" icon={['fas', 'chevron-down']} />
						</u>
					)}
					{expanded && size(commentsToShow) > 10 && (
						<u
							className="cursor-pointer"
							onClick={() => this.setState({ expanded: false })}
						>
							Show less
							<FontAwesomeIcon className="ml-1" icon={['fas', 'chevron-up']} />
						</u>
					)}
				</div>
			</div>
    )
  }
}

export default EntityCommentList



// WEBPACK FOOTER //
// ./src/common/EntityCommentList.component.tsx